import {AsyncProcessState} from "./asyncProcessTypes";

const INITIAL_ASYNC_PROCESS_STATE: AsyncProcessState = {
  isRequestPending: false,
  isRequestFetched: false,
  data: null,
  error: null
};

const EMPTY_LIST_ASYNC_PROCESS_STATE: AsyncProcessState<ListRequestResponse<any>> = {
  isRequestPending: false,
  isRequestFetched: true,
  data: {
    count: 0,
    next: null,
    previous: null,
    results: []
  },
  error: null
};

export {INITIAL_ASYNC_PROCESS_STATE, EMPTY_LIST_ASYNC_PROCESS_STATE};
